import { settingsApiRequest } from '../../screens/settings/settingsApi';

const handler = async (article, { rejectWithValue }) => {
  try {
    const data = await settingsApiRequest({
      method: 'POST',
      path: '/settings/article',
      body: article,
    });
    return { article: data };
  } catch (error) {
    console.error('services.articles.createArticle@handler', error);
    return rejectWithValue({ status: error.status, message: error.message });
  }
};

const pending = (state) => ({ ...state, creating: true });
const fulfilled = (state, action) => ({
  ...state,
  creating: false,
  lists: [...state.lists, action.payload.article],
});
const rejected = (state) => ({ ...state, creating: false });

export default { handler, pending, fulfilled, rejected };
